<template>
  <div>
    <app-input-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import GrpInsAssignmentSetup from "../../../components/insurance/grpinsassignment/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-input-form": GrpInsAssignmentSetup,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('recgrpinsuranceassignment.grpinsuranceassignmentsetup'),
      pageTitleValue: "",
      formData: {
        staffid: null,
        staffcode: null,
        staffname: null,
        compnyname: null,
        inspolicyid: null,
        policyno: null,
        startdate: null,
        enddate: null,
        policydesc: null,
        dependentdetail: [],
        insurancedetail: [],
        stamp: 0,
        userid: this.$store.getters.userId,
      },

      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      this.$store.dispatch('post', {url: "/grpinsassignment/create", payload: vm.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "grpinsassignmentlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "grpinsassignmentlist" });
    },
  },
};
</script>